document.addEventListener('DOMContentLoaded', () => {
  const initSlider = () => {
    const track = document.querySelector('.best-sellers__track');
    const prev = document.querySelector('.best-sellers__arrow--left');
    const next = document.querySelector('.best-sellers__arrow--right');
    const thumb = document.querySelector('.best-sellers__scrollbar-thumb');

    if (!track || !prev || !next) return;

    const card = track.querySelector('.best-sellers__card');
    const scrollAmount = card ? card.offsetWidth + 25 : 350;

    const updateUI = () => {
      const maxScroll = track.scrollWidth - track.clientWidth;
      const scrollLeft = track.scrollLeft;

      // 1. Desactivar flechas visualmente en los extremos
      prev.style.opacity = scrollLeft <= 5 ? '0.2' : '1';
      prev.style.pointerEvents = scrollLeft <= 5 ? 'none' : 'auto';

      next.style.opacity = scrollLeft >= maxScroll - 5 ? '0.2' : '1';
      next.style.pointerEvents = scrollLeft >= maxScroll - 5 ? 'none' : 'auto';

      // 2. Movimiento sincronizado de la barra de progreso
      if (thumb && maxScroll > 0) {
        const scrollPercentage = scrollLeft / maxScroll;
        // Si el thumb mide 25% de ancho, se desplaza por el 75% restante
        thumb.style.left = (scrollPercentage * 75) + '%';
      }
    };

    // Eventos Click
    prev.addEventListener('click', () => {
      track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });

    // Sincronización en tiempo real
    track.addEventListener('scroll', updateUI);
    window.addEventListener('resize', updateUI);
    
    updateUI();
  };

  initSlider();
  document.addEventListener('shopify:section:load', initSlider);
});

// Reveal Animation (Intersection Observer)
const bestSellersSection = document.querySelector('.best-sellers');
if (bestSellersSection && 'IntersectionObserver' in window) {
  const observer = new IntersectionObserver(([entry]) => {
    if (entry.isIntersecting) {
      bestSellersSection.classList.add('is-visible');
      observer.disconnect();
    }
  }, { threshold: 0.15 });
  observer.observe(bestSellersSection);
}